import ProfileVO from '../profiles/ProfileVO';

export enum ProfileContentType {
  PROJECT = 'PROJECT',
  DOCUMENT = 'DOCUMENT',
  DESCRIPTION = 'DESCRIPTION',
  CONTROLS = 'CONTROLS',
  IMAGE = 'IMAGE',
  SUB_PROCESSOR = 'SUB_PROCESSOR',

  PROFILE = 'PROFILE',
  PROFILE_SECTION = 'PROFILE_SECTION',
  PQ = 'PQ',
  PQ_SECTION = 'PQ_SECTION',
  PQ_QA = 'PQ_QA',
  PQ_ATTACHMENT = 'PQ_ATTACHMENT',
  PD = 'PD'
}

export enum ContentSourceStatus {
  PENDING = 'PENDING',
  READY = 'READY',
  ERROR = 'ERROR'
}

export default interface ProfileContentVO {
  id: string;
  name: string;
  profileId: string;
  profileName: string;
  profileDetails: ProfileVO;
  sectionId: string;
  sectionName: string;
  contentType: ProfileContentType;
  sourceStatus: ContentSourceStatus;
  sourceRefId: string;
  createdDate: Date;
  updatedDate: Date;
  createdBy: string;
  updatedBy: string;
  hasUpdate: boolean;
  version: number;
  contentInfo: Record<string, unknown>;
  sortingOrder: number;
  entityId: string;
  viewedCount: number;
  downloadCount: number;
  requestAccess: boolean;
  ndaAccess: boolean;
  viewOnlyAccess: boolean;
  includeWatermark?: boolean;
  thumbnailImageId?: string;
  anonymousViewedCount?: number;
  anonymousDownloadCount?: number;
  timeSpent?: number;
  anonymousTimeSpent?: number;
  isDownloadStarted?: boolean;
  retryCount?: number;

  isActive?: boolean;
  isLocked?: boolean;
  textMsg?: string;
  internalName?: string;
  contentName: string;
  token?: string;
}

export enum ProfileSectionView {
  LIST = 'LIST',
  TILE = 'TILE',
  THUMBNAIL = 'THUMBNAIL'
}

export enum ContentGatingStatus {
  LOCKED = 'LOCKED',
  VALIDATE_USING_OTP = 'VALIDATE_USING_OTP',
  APPROVAL_PENDING = 'APPROVAL_PENDING',
  SIGN_NDA = 'SIGN_NDA',
  RECLAIM_ACCESS = 'RECLAIM_ACCESS',
  UNLOCKED = 'UNLOCKED'
}
